export var single = [
  {
    name: 'Germany',
    value: 8940000,
  },
  {
    name: 'USA',
    value: 5000000,
  },
  {
    name: 'France',
    value: 7200000,
  },
];

export var multi = [
  {
    name: 'Lunes',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },

  {
    name: 'martes',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
  {
    name: 'Miercoles',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
  {
    name: 'Jueves',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
  {
    name: 'Viernes',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
  {
    name: 'Sabado',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
  {
    name: 'Domingo',
    series: [
      {
        name: '01',
        value: 0,
      },
      {
        name: '02',
        value: 0,
      },
      {
        name: '03',
        value: 0,
      },
      {
        name: '04',
        value: 0,
      },
      {
        name: '05',
        value: 0,
      },
      {
        name: '06',
        value: 0,
      },
      {
        name: '07',
        value: 0,
      },
      {
        name: '08',
        value: 0,
      },
      {
        name: '09',
        value: 0,
      },
      {
        name: '10',
        value: 0,
      },
      {
        name: '11',
        value: 0,
      },
      {
        name: '12',
        value: 0,
      },
      {
        name: '13',
        value: 0,
      },
      {
        name: '14',
        value: 0,
      },
      {
        name: '15',
        value: 0,
      },
      {
        name: '16',
        value: 0,
      },
      {
        name: '17',
        value: 0,
      },
      {
        name: '18',
        value: 0,
      },
      {
        name: '19',
        value: 0,
      },
      {
        name: '20',
        value: 0,
      },
      {
        name: '21',
        value: 0,
      },
      {
        name: '22',
        value: 0,
      },
      {
        name: '23',
        value: 0,
      },
    ],
  },
];
